import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { Icon } from "@iconify/react";
import { formatK, formatNumber, niceCeil } from "../../utils/dashboardFormat";

const HourlyMessageAnalytics = ({ charts, legacy }) => {
    const hourly = charts?.hourlyActivity || legacy || {};

    const labels = Array.isArray(hourly.labels) ? hourly.labels : [];
    const data = Array.isArray(hourly.data) ? hourly.data.map((n) => Number(n) || 0) : [];
    const total = hourly.total ?? data.reduce((a, b) => a + b, 0);
    const max = hourly.max ?? Math.max(0, ...data);
    const hasData = labels.length > 0 && data.some((n) => n > 0);

    const series = useMemo(() => [{ name: "Messages", data }], [data]);

    const options = useMemo(
        () => ({
            chart: {
                toolbar: { show: false },
                zoom: { enabled: false },
                fontFamily: "inherit",
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    columnWidth: "55%",
                },
            },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 2, colors: ["transparent"] },
            xaxis: {
                categories: labels,
                labels: {
                    rotate: -45,
                    style: { fontSize: "10px", colors: "#667781" },
                },
                axisBorder: { show: false },
                axisTicks: { show: false },
            },
            yaxis: {
                min: 0,
                max: niceCeil(max),
                tickAmount: 4,
                labels: {
                    formatter: (val) => formatK(val),
                    style: { colors: "#667781", fontSize: "11px" },
                },
            },
            fill: {
                opacity: 1,
                colors: ["#00a884"],
            },
            grid: {
                borderColor: "#eef1f4",
                strokeDashArray: 4,
            },
            tooltip: {
                y: {
                    formatter: (val) => `${formatNumber(val)} messages`,
                },
            },
        }),
        [labels, max]
    );

    return (
        <div className="col-xxl-4 col-lg-4 col-md-12">
            <div className="card h-100 radius-8 border">
                <div className="card-body p-24">
                    <div className="mb-3">
                        <h6 className="mb-1 text-lg">Hourly Activity</h6>
                        <p className="mb-0 text-secondary-light text-sm">
                            Last 24 hours · {formatNumber(total)} messages
                        </p>
                    </div>

                    {hasData ? (
                        <ReactApexChart
                            options={options}
                            series={series}
                            type="bar"
                            height={280}
                        />
                    ) : (
                        <div className="dash-empty">
                            <Icon icon="mdi:chart-bar" />
                            <span>No hourly activity yet</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HourlyMessageAnalytics;
